import type { DimensionValue, StyleProp, ViewStyle } from 'react-native';

import { getStyleSheet } from './style-sheet-memo';

export const mr = (margin: DimensionValue): StyleProp<ViewStyle> =>
  getStyleSheet({ marginRight: margin });

export const ml = (margin: DimensionValue): StyleProp<ViewStyle> =>
  getStyleSheet({ marginLeft: margin });

export const mt = (margin: DimensionValue): StyleProp<ViewStyle> =>
  getStyleSheet({ marginTop: margin });

export const mb = (margin: DimensionValue): StyleProp<ViewStyle> =>
  getStyleSheet({ marginBottom: margin });

export const mv = (margin: DimensionValue): StyleProp<ViewStyle> =>
  getStyleSheet({ marginVertical: margin });

export const mh = (margin: DimensionValue): StyleProp<ViewStyle> =>
  getStyleSheet({ marginHorizontal: margin });

export const margin = (margin: DimensionValue): StyleProp<ViewStyle> =>
  getStyleSheet({ margin });
